import moment from 'moment';

/**
 * Convert 12 to 24 hours
 * @param time
 * @returns {number}
 */
export const convert24HourTime = (time) => {
  const hours = parseInt(time.hours, 10);
  return time.meridiem === 'PM'
    ? hours === 12 ? hours : hours + 12
    : hours === 12 ? 0 : hours;
};

/**
 * Format time object to time format of 12/24 hour modes
 * @param time
 * @param support24
 * @returns {string}
 */
export const formatTime = (time, support24) => {
  const currentTime = moment('00:00', 'HH:mm');
  currentTime.set({
    hour: support24 ? time.hours : convert24HourTime(time),
    minute: time.minutes
  });
  return currentTime.format(support24 ? 'HH:mm' : 'hh:mm A');
};

/**
 * Get hours from string based on mode
 * @param time
 * @param support24
 * @returns {number}
 */
export const getHours = (time, support24) => {
  const timeValues = time.split(':');
  const hours = parseInt(timeValues[0], 10);
  const meridiem = time.split(' ')[1];
  if (support24) {
    if (meridiem === 'PM') {
      return hours === 12 ? 12 : hours + 12;
    }
    if (meridiem === 'AM' && hours === 12) {
      return 0;
    }
    return hours;
  }
  if (hours === 0) {
    return 12;
  }
  if (hours > 12) {
    return hours - 12;
  }
  return hours;
};

/**
 * Get meridiem value from string or calculate it if not given
 * @param time
 * @returns {string}
 */
export const getMeridiem = (time) => {
  const timeValues = time.split(' ');
  const meridiemString = timeValues[1];
  return meridiemString || (getHours(time, true) >= 12
    ? 'PM'
    : 'AM');
};

/**
 * Get time object from time string
 * @param time
 * @param support24
 * @returns {{hours: *, minutes: *, meridiem: (null|*)}}
 */
export const getTime = (time, support24) => {
  const timeValues = time.split(':');
  return {
    hours: getHours(time, support24),
    minutes: parseInt(timeValues[1].split(' ')[0], 10),
    meridiem: support24 ? null : getMeridiem(time)
  };
};

/**
 * Generate default time value
 * @param support24
 * @returns {string}
 */
export const generateTime = (support24) => (
  support24 ? '12:00' : '12:00 PM'
);

/**
 * Check if the selected time is between time limits for AM/PM time format
 * @param atTime
 * @param minTime
 * @param maxTime
 * @returns {boolean}
 */
export const isInTimeRange = (atTime, minTime = '12:00 AM', maxTime = '11:59 PM') => {
  const current = moment(atTime, 'hh:mm A');
  const isSame = current.isSame(moment(minTime, 'hh:mm A'));
  const isBeforeMin = current.isBefore(moment(minTime, 'hh:mm A'));
  const isAfterMax = current.isAfter(moment(maxTime, 'hh:mm A'));

  return isSame || (!isBeforeMin && !isAfterMax);
};
